export enum Role {
  ACCOUNT_MANAGER = "account_manager",
  PROJECT_MANAGER = "project_manager",
  CLIENT = "client",
}

export interface CreateBusinessUserDto {
  firstName: string;
  lastName: string;
  email: string;
  phoneCode: string;
  phoneNumber: string;
  password: string;
  companyName: string;
  /** Preferred; API also accepts legacy companyType. */
  businessType: string;
  /** Preferred; API also accepts legacy companyIndustry. */
  industry: string;
  companyCountryOfRegistration: string;
  defaultCurrency: string;
  signupSource?: string;
  otherIndustry?: string;
  invitationToken?: string;
}
